var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 14.0417V8.71144C15.625 8.28192 15.5376 7.85689 15.3682 7.4622C15.1987 7.06752 14.9508 6.71143 14.6394 6.4156L9.59092 1.62048C9.29666 1.34093 8.90627 1.18506 8.5004 1.18506C8.09452 1.18506 7.70414 1.34093 7.40988 1.62048L2.36062 6.4156C2.04922 6.71143 1.80126 7.06752 1.63182 7.4622C1.46238 7.85689 1.375 8.28192 1.375 8.71144V14.0417C1.375 14.4617 1.54181 14.8644 1.83875 15.1613C2.13568 15.4582 2.53841 15.6251 2.95833 15.6251H14.0417C14.4616 15.6251 14.8643 15.4582 15.1613 15.1613C15.4582 14.8644 15.625 14.4617 15.625 14.0417Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.f672a6d5fe69c122728dbd28a9fe38cf.svg";
export { ForwardRef as ReactComponent };